import { render, staticRenderFns } from "./tab-wrap.vue?vue&type=template&id=3cc63fac"
import script from "./tab-wrap.vue?vue&type=script&lang=js"
export * from "./tab-wrap.vue?vue&type=script&lang=js"
import style0 from "./tab-wrap.vue?vue&type=style&index=0&id=3cc63fac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports